<template>
	<div class="financial-analysis-table">
		<div class="container-analysis">
			<div class="title">Captação {{ monthly ? 'Mensal' : 'Anual' }}</div>
		</div>

		<div class="table-container">
			<table>
				<thead :class="{ 'financial-padding-right': tableDataLength > 6 }">
					<tr>
						<th class="resume">Resumo</th>
						<th class="th-default">Captação Tabela</th>
						<th class="th-default">Captação Proposta</th>
						<th class="th-default">Variação Captação</th>
					</tr>
				</thead>

				<tbody class="scroll-color">
					<tr v-for="(serie, index) in tableData.result" :key="index">
						<td class="td">
							{{ serie.data | moment('DD/MM/YYYY') }}
						</td>
						<td class="value-default">
							<div class="value-default-separate">
								{{ serie.valor_estatico | currencyBRL }}
							</div>
						</td>
						<td class="value-default">
							<div class="value-default-separate">
								{{ serie.valor_dinamico || 0 | currencyBRL }}
							</div>
						</td>
						<td class="value-default" :class="getRowStatus(serie.row_color)">
							<div class="value-default-separate ">
								{{ serie.diferenca | currencyBRL }}
							</div>
							<div class="value-default-separate">
								{{ serie.porcentagem }}
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import { currencyBRL } from '@/filters';
import { mapGetters } from 'vuex'

export default {
	name: 'ui-simulation-capture-analysis',

	components: {},

	filters: { currencyBRL },

	props: {
		// series: {
		// 	type: [Object, Array],
		// 	required: true
		// },
		// staticSeries: {
		// 	type: [Object, Array],
		// 	required: true
		// },
		monthly: {
			type: Boolean,
			required: true
		}
	},
	created() {
		return this.tableData;
	},
	methods: {
		getRowStatus(value) {
			return `${value ?? ''} value-separated`
		},
		returnBiggestValue(value1, value2){
			return {'max':Math.max(value1, value2), 'min':Math.min(value1, value2)}
		}
	},
	computed: {
		...mapGetters('simulation', {
            simulation: 'getSimulation',
            staticSeries: 'getStaticSeries',
            series: 'getSeries',
        }),
		tableData() {
			// Se for mensal, usa 7 no slice pra separar a data por mes, se não, usa 4 pra retornar separado por ano
			let isMonthly = this.monthly ? 7 : 4;
			const seriesArray = Object.values(this.staticSeries);
			const seriesSimulation = Object.values(this.series);
			const allYearsSet = new Set();
			const fullDatesMap = new Map();
			const yearlyTotalsStatic = {};
			const yearlyTotalsSimulation = {};

			const addValueToYear = (group, installment, serie = []) => {
				let year = installment.duedate?.slice(0, isMonthly);
				let fullDate = installment.duedate;
				let pvValue = typeof installment.pv === 'number' ? installment.pv : parseFloat(installment.pv);
				if(serie?.type_installment === 'fixed_value'){
					pvValue = parseFloat(serie.first_value);
					fullDate = serie.first_date;
					year = fullDate.slice(0, isMonthly);
				}
				if (!group[year]) {
					group[year] = 0;
				}

				if (year) {
					group[year] += pvValue;
					fullDatesMap.set(year, fullDate);
				}
			};

			seriesArray.forEach((serie) => {
				if(serie.type_installment ==='fixed_value'){
					addValueToYear(yearlyTotalsStatic, [], serie);
					allYearsSet.add(serie.first_date?.slice(0, isMonthly));
					return
				}
				serie.installments.forEach(installment => {
					addValueToYear(yearlyTotalsStatic, installment );
					allYearsSet.add(installment.duedate?.slice(0, isMonthly));
				});
			});

			seriesSimulation.forEach((serie) => {
				if(serie.type_installment ==='fixed_value'){
					addValueToYear(yearlyTotalsSimulation, [], serie);
					allYearsSet.add(serie.first_date?.slice(0, isMonthly));
					return
				}
				serie.installments.forEach(installment => {
					addValueToYear(yearlyTotalsSimulation, installment);
					allYearsSet.add(installment.duedate?.slice(0, isMonthly));
				});
			});
		
			const allYears = Array.from(allYearsSet).sort();
			const result = {};
			let valorTabela = 0;
			let valorProposta = 0;

			allYears.forEach(date => {
				const valorEstatico = yearlyTotalsStatic[date] || 0;
				const valorDinamico = yearlyTotalsSimulation[date] || 0;

				valorTabela += valorEstatico;
				valorProposta += valorDinamico;

				let rowStatus = '';

				if( valorTabela > valorProposta ) rowStatus = 'negative';
				if( valorTabela < valorProposta ) rowStatus = 'positive';

				const { max, min } = this.returnBiggestValue(valorTabela, valorProposta);
				const diferenca = max - min;

				let porcentagem = 0.00;

				if (diferenca > 0 ) porcentagem = ((valorProposta - valorTabela) * 100 / valorTabela);
				const fullDate = fullDatesMap.get(date);
				result[date] = {
					data: fullDate,
					valor_estatico: valorTabela,
					valor_dinamico: valorProposta,
					diferenca: diferenca.toFixed(6) <= 0 ? 0 : diferenca.toFixed(2),
					porcentagem: porcentagem.toFixed(6) == 0 ? '0.00%' : porcentagem.toFixed(2) + '%',
					row_color: rowStatus ?? ''
				};
			});

			return {
				series: seriesArray.map(({ installments, first_date, first_value, percent, last_date }) => ({
					installments,
					first_date,
					first_value,
					percent,
					last_date
				})),
				seriesSimulation: seriesSimulation.map(({ installments, first_date, first_value, percent, last_date }) => ({
					installments,
					first_date,
					first_value,
					percent,
					last_date
				})),
				result
			};
		},
		tableDataLength() {
			return Object.values(this.tableData.result).length
		}
	},
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>